<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 16a8 8 0 0 1-3.916-1.021l-3.655.914a.264.264 0 0 1-.323-.32l.914-3.655A8.01 8.01 0 0 1 8 0a8.009 8.009 0 0 1 8 8 8.008 8.008 0 0 1-8 8ZM4.285 9.5a.27.27 0 0 0-.286.25v1a.27.27 0 0 0 .286.25h7.428a.27.27 0 0 0 .286-.25v-1a.27.27 0 0 0-.286-.25H4.285Zm0-3.5a.27.27 0 0 0-.286.25v1a.27.27 0 0 0 .286.25h7.428a.27.27 0 0 0 .286-.25v-1a.27.27 0 0 0-.286-.25H4.285Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering180',
});
</script>
